'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var useContentSwitcher = require('./useContentSwitcher.js');
var reactUtils = require('@chakra-ui/react-utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "className", "isFitted"],
  _excluded2 = ["htmlProps", "descendants"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var isFirst = function isFirst(array, index) {
  return index === 0;
};
var isLast = function isLast(array, index) {
  return index === array.length - 1;
};
var isMiddle = function isMiddle(array, index) {
  return !isFirst(array, index) && !isLast(array, index);
};
/**
 * ContentSwitcher
 *
 * Allow users to toggle between alternate views of similar or related content.
 * Only one content section is shown at a time.
 */
var ContentSwitcher = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('ContentSwitcher', props);
  var _omitThemingProps = react.omitThemingProps(props),
    children = _omitThemingProps.children,
    className = _omitThemingProps.className;
  _omitThemingProps.isFitted;
  var rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var _useContentSwitcher = useContentSwitcher.useContentSwitcher(rest),
    htmlProps = _useContentSwitcher.htmlProps,
    descendants = _useContentSwitcher.descendants,
    ctx = _objectWithoutProperties__default["default"](_useContentSwitcher, _excluded2);
  var context = React__default["default"].useMemo(function () {
    return ctx;
  }, [ctx]);
  var rootProps = htmlProps;
  var contentSwitcherStyles = _objectSpread({
    display: 'flex',
    '> *:first-of-type:not(:last-of-type)': {
      borderEndRadius: 0,
      borderRightWidth: 0
    },
    '> *:not(:first-of-type):not(:last-of-type)': {
      borderRadius: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0
    },
    '> *:not(:first-of-type):last-of-type': {
      borderStartRadius: 0,
      borderLeftWidth: 0
    }
  }, styles.container);
  var validChildren = reactUtils.getValidChildren(children);
  return /*#__PURE__*/React__default["default"].createElement(useContentSwitcher.ContentSwitcherDescendantsProvider, {
    value: descendants
  }, /*#__PURE__*/React__default["default"].createElement(useContentSwitcher.ContentSwitcherProvider, {
    value: context
  }, /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx('chakra-contentSwitcher', className),
    ref: ref
  }, rootProps, {
    __css: contentSwitcherStyles
  }), validChildren.map(function (child, index) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: "switch-".concat(index)
    }, (isMiddle(validChildren, index) || isLast(validChildren, index)) && /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
      className: "chakra-contentSwitcher__separator",
      "aria-hidden": "true",
      __css: styles.separator
    }), child);
  })))));
});
ContentSwitcher.displayName = 'ContentSwitcher';
exports.ContentSwitcher = ContentSwitcher;